import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import store from '../store'

Vue.use(Vuex, axios)

const createHeader = function () {
  const credential = store.getters['config/getCredential']
  var userLang = navigator.language || navigator.userLanguage
  var headerObj = {};
  if (credential) {
    if (!credential.locale) {
      credential.locale = userLang.replace('-', '_')
    }
    if (credential && credential.apiEncryptedUser) {
      headerObj = {
        'X-ApiEncryptedUser': credential.apiEncryptedUser
      }
    } else if (credential && credential.apiKey) {
      headerObj = {
        'X-ApiKey': credential.apiKey
      }
    }
  }
  return headerObj;
}

export default {

  getCartItems(request) {
    const credential = store.getters['config/getCredential']
    const params = new URLSearchParams();
    params.append('locale', credential?.locale);

    return axios
      .post(`${process.env.VUE_APP_BASE_URL}/cart/cart-items` , request,
        {
          headers: createHeader(),
          params: params
        }
      )
  },

}
